import { React, useEffect, useState } from 'react';
import ProfileCard from '../../../molecules/pursuitLeader/components/dashboard/profileCard';
import DataCardOne from '../../../molecules/pursuitLeader/components/dashboard/dataCardOne';
import DataCardTwo from '../../../molecules/pursuitLeader/components/dashboard/dataCardTwo';
import DataCardThree from '../../../molecules/pursuitLeader/components/dashboard/dataCardThree';
import { PersonalContainer } from '../../../atoms/dashboard/personalDashboard.styles';
import { useRecoilValue } from 'recoil';
import {
  Current_User,
  Recoil_Quarter_State,
  System_Date_Time_State,
} from '../../../../recoil/recoil';
import { getMyDashboardData } from '../../../../services/pursuitLeaderServices';
import { getDashboardProfileDetails } from '../../../../services/commonServices';
import { getTodaysDate } from '../../../../util/commonUtil';

const PersonalDashboard = () => {
  let quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const [desktopData, setDesktopData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const todaysDate = getTodaysDate(systemDateTime);

  useEffect(async () => {
    if (quarterInfo != null) {
      let myDesktopData = await getMyDashboardData(
        quarterInfo.fiscal_year,
        currentUser.email,
        todaysDate,
      );
      setDesktopData(myDesktopData);

      let myProfileDate = await getDashboardProfileDetails(currentUser.email);
      setProfileData(myProfileDate);
    }
  }, [quarterInfo]);

  return (
    <>
      {quarterInfo != null && desktopData != null && profileData != null && (
        <PersonalContainer>
          <ProfileCard data={profileData} />
          <DataCardOne data={desktopData.forecast_accuracy} />
          <DataCardTwo data={desktopData.forecast_completion} />
          <DataCardThree data={desktopData.open_close_duration} />
        </PersonalContainer>
      )}
    </>
  );
};

export default PersonalDashboard;
